import { Component, Input, OnChanges } from '@angular/core';
import { HorizontalListData } from 'common';
import { AccountStatementsData } from '../account.model';
import { AccountStatementsDataWidgetAdapter } from './account-statements-widget.data';

@Component({
    selector: 'ifb-account-statements-widget',
    templateUrl: './account-statements-widget.component.html',
    styleUrls: ['./account-statements-widget.component.scss'],
    providers: [AccountStatementsDataWidgetAdapter],
    standalone: false
})
export class AccountStatementsWidgetComponent implements OnChanges {
  listItems: HorizontalListData[];

  @Input()
  data: AccountStatementsData;

  @Input()
  canEditAccountDocumentsGeneration: boolean;

  @Input()
  canViewAccountDocumentsGeneration: boolean;

  constructor(private readonly adapter: AccountStatementsDataWidgetAdapter) { }

  ngOnChanges(): void {
    this.listItems = this.adapter.adaptListData(this.data, this.canViewAccountDocumentsGeneration);
  }
}
